(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8685],{

/***/ 59181:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Errors = {
  ERR_REFUND_ORDER_PROCESSING: "You have already requested a refund for this order",
  ERR_EMPLOYEE_ALREADY_EXISTS: "You already have a staff member with this info",
  ERR_UNAUTHORIZED: "Your credentials have expired, you need to log in again",
  ERR_ACCOUNT_BALANCE_LOW: "You don't have enough balance",
  ERR_ORDER_SETTLEMENT_PROCESSED: "Orders in which the settlement process has started cannot be refunded",
  ERR_LOGIN_CREDENTIALS: "Wrong email or password",
  ERR_PASSWORD_WRONG: "Wrong password",
  ERR_TWO_FA_ALREADY_ENABLED: "2fa already enabled",
  ERR_CONTACT_ID_INVALID: "Contact not found",
  ERR_ADDRESS_NOT_FOUND: "Address not generated yet, please contact support",
  ERR_VALIDATION: "Wrong details provided",
  ERR_EMAIL_NOT_FOUND: "Email not found",
  ERR_TWO_FA_CODE_INVALID: "2FA code is invalid or has expired. Please try again",
  UNKNOWN: "An unknown error occurred. Please try again in a few minutes. If the problem persists contact support",
  SUCCESS_LOGIN_OTP_VERIFICATION_CODE: "We sent a new code to your email address",
  ERR_CODE_ALREADY_SENT: "A code was already sent to your email.",
  ERR_VERIFICATION_CODE_INVALID: "Verification code is invalid or has expired. Please try again",
  VALIDATION_FAILED: "Please verify your email and password",
  ERR_EMAIL_OR_PASSWORD_WRONG: "Please verify your email and password",
  ERR_CAPTCHA_REQUIRED: "Please verify captcha to continue.",
  ERR_INVALID_CAPTCHA: "Invalid captcha",
  ERR_ORDER_REFUND_EXISTS: "This order has already been refunded",
  ERR_PHONE_ALREADY_EXISTS: "Phone number is already in use. Please verify or specify a new phone number.",
  ERR_EMAIL_ALREADY_EXISTS: "Email address is already in use. Please verify or specify a new email.",
  ERR_CUSTOMER_NOT_FOUND: "We could not find this email in our database. Please verify.",
  ERR_CUSTOMER_NAME_INVALID: "Name field can only contain a first and a last name.",
  ERR_TWO_FA_CODE: "2FA code is invalid or has expired. Please try again.",
  ERR_DEPOSIT_ADDRESS_REQUIRED: "Please verify that your deposit address is valid.",
  ERR_ORDER_PROCESSED: "Order with current state can't be refunded",
  ERR_PASSWORDS_NOT_MATCHING: "New passwords do not match. Please verify",
  ERR_AMOUNT_LOW: "Amount is less than minimum required",
  ERR_HAS_UNPAID_INVOICES: "You can't ask for new loan before paying active ones",
  ERR_NO_API_USERS: "You need to activate your API keys. Please contact support@datamynt.zendesk.com",
  ERR_NETWORK_NOT_SUPPORTED: "This network is currently not supported",
  ERR_INVALID_ADDRESS: "Please verify if all the added addresses are valid",
  ERR_ASSET_NOT_SWAPPABLE: "Asset is not swappable",
  ERR_INVOICE_NOT_PAID: "You cannot refund an invoice which is not yet paid",
  ERR_WITHDRAWAL_REQUEST_PENDING: "Withdrawal request can't be processed, while there is a pending withdrawal request",
  ERR_INVOICE_REFUND_EXISTS: "A refund has already been processed for this invoice",
  ERR_EXPORT_REQUEST_EXISTS: "We can't process this request as there is an existing export request",
  ERR_SETTLEMENT_ISSUE: "There is an issue with settlement. Please contact support for more details",
  ERR_FIAT_SETTLEMENT_RATE: "Rates are not available currently. Please contact support for more details",
  ERR_BANK_ACCOUNT: "There is a problem verifying bank account. Please contact support for more details",
  ERR_BANK_ACCOUNT_EXISTS: "Bank account details already exists",
  ERR_SETTLEMENT_AMOUNT: "Settlement amount can be >= 500 NGN and <= 10000000 NGN"
};
/* harmony default export */ __webpack_exports__["Z"] = (Errors);

/***/ }),

/***/ 64293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79352);
/* harmony import */ var _helpers_theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12454);
/* harmony import */ var _hooks_useErrorHandling__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59269);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47965);
/* harmony import */ var _contexts_Dashboard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22100);
/* harmony import */ var react_lottie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79464);
/* harmony import */ var _public_red_dot_json__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56058);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11248);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);
















function Banner(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      visible = _useState[0],
      setVisible = _useState[1];

  var theme = (0,_helpers_theme__WEBPACK_IMPORTED_MODULE_11__/* .getCurrentTheme */ .g)();

  var _useErrorHandling = (0,_hooks_useErrorHandling__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      withErrorHandling = _useErrorHandling.withErrorHandling;

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      options = _useState3[0],
      setOptions = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      buyPrice = _useState4[0],
      setBuyPrice = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      sellPrice = _useState5[0],
      setSellPrice = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      KESBuyPrice = _useState6[0],
      setKESBuyPrice = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      KESSellPrice = _useState7[0],
      setKESSellPrice = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      kesOptions = _useState8[0],
      setKESOptions = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      blink = _useState9[0],
      setBlink = _useState9[1];

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_Dashboard__WEBPACK_IMPORTED_MODULE_6__/* .DashboardContext */ .G),
      selectedOrg = _useContext.state.selectedOrg,
      dispatch = _useContext.dispatch;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var getNGNCurrencyPrice = /*#__PURE__*/function () {
      var _ref = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _yield$withErrorHandl, data, error, filteredOptions;

        return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return withErrorHandling(_helpers_api__WEBPACK_IMPORTED_MODULE_5__/* .apiGetCurrencyRatesNGN */ .bT);

              case 2:
                _yield$withErrorHandl = _context.sent;
                data = _yield$withErrorHandl.data;
                error = _yield$withErrorHandl.error;

                if (error) {
                  setError(error);
                  setBuyPrice(null);
                  setSellPrice(null);
                } else {
                  setBuyPrice(data.buyPrice + " NGN");
                  setSellPrice(data.sellPrice + " NGN");
                  filteredOptions = data;
                  setOptions(filteredOptions);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getNGNCurrencyPrice() {
        return _ref.apply(this, arguments);
      };
    }();

    getNGNCurrencyPrice();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var getKESCurrencyPrice = /*#__PURE__*/function () {
      var _ref2 = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        var _yield$withErrorHandl2, data, error, filteredKesOptions;

        return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return withErrorHandling(_helpers_api__WEBPACK_IMPORTED_MODULE_5__/* .apiGetCurrencyRatesKES */ ._N);

              case 2:
                _yield$withErrorHandl2 = _context2.sent;
                data = _yield$withErrorHandl2.data;
                error = _yield$withErrorHandl2.error;

                if (error) {
                  setError(error);
                  setBuyPrice(null);
                  setSellPrice(null);
                } else {
                  setKESBuyPrice(data.buyPrice);
                  setKESSellPrice(data.sellPrice);
                  filteredKesOptions = data;
                  setKESOptions(filteredKesOptions);
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getKESCurrencyPrice() {
        return _ref2.apply(this, arguments);
      };
    }();

    getKESCurrencyPrice();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (props.currentCurrency === "NGN") {
      setBuyPrice(options !== null && options !== void 0 && options.buyPrice ? (options === null || options === void 0 ? void 0 : options.buyPrice) + " NGN" : "---");
      setSellPrice(options !== null && options !== void 0 && options.sellPrice ? (options === null || options === void 0 ? void 0 : options.sellPrice) + " NGN" : "---");
    }

    if (props.currentCurrency === "KSH") {
      setBuyPrice(KESBuyPrice ? KESBuyPrice + " KES" : "---");
      setSellPrice(KESSellPrice ? KESSellPrice + " KES" : "---");
    }
  }, [props]);
  var redDotOptions = {
    loop: true,
    autoplay: true,
    animationData: blink ? _public_red_dot_json__WEBPACK_IMPORTED_MODULE_8__ : null,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var interval = setInterval(function () {
      setBlink(function (b) {
        return !b;
      });
    }, 500);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: visible ? " flex items-center p-[16px] relative rounded-3xl flex flex-col md:flex-row  max-w-[520px]  mx-auto bg-[#2E2F31] text-white text-3xl font-bold font-sans text-[16px] gap-y-6 md:gap-y-0 md:gap-x-6 lg:gap-x-12 lg:ml-20 ml-8 mr-8" : "hidden ",
      style: {
        backgroundColor: ""
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: "flex text-white text-3xl font-bold font-sans text-[16px] flex-col gap-y-4 md:flex-col ",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "flex flex-row",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
            src: "/Group41875.svg",
            width: 30,
            height: 30,
            alt: ""
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
            className: "ml-2",
            children: "Current Rates "
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "flex flex-col sm:flex-row",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "flex justify-between ",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("p", {
              className: "",
              children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "text-[#0EA363]",
                children: " Buy: "
              }), "1 USD=", " ", buyPrice ? "".concat(buyPrice, " ") : "--- "]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: "flex justify-between",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "mt-[-10px] hidden sm:block ml-8 mr-8",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "/Ellipse168.svg",
                width: 6,
                height: 6,
                alt: ""
              })
            }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("p", {
              className: "",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "text-[#FB547C]",
                children: " Sell:"
              }), " 1 USD=", " ", sellPrice ? "".concat(sellPrice, " ") : "--- "]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
        type: "button",
        className: "absolute right-3 top-4 text-white text-xl h-full flex items-top md:items-top",
        onClick: function onClick() {
          return setVisible(false);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_13__/* .RiCloseFill */ .tgW, {})
      })]
    })
  });
}

/***/ }),

/***/ 22100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DashboardContext; },
/* harmony export */   "_": function() { return /* binding */ DashboardProvider; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {
  accounts: null,
  currentPage: "Dashboard",
  contacts: null,
  user: null,
  totalBalance: null,
  totalInterest: null,
  selectedOrg: null,
  selectedAccount: null,
  twoFaEnabled: null,
  contactsUpdated: false
};

var reducer = function reducer(state, action) {
  var newState;
  var callbacks = {
    SET_ACCOUNTS: function SET_ACCOUNTS() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        accounts: action.value
      });
    },
    SET_CONTACTS: function SET_CONTACTS() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        contacts: action.value
      });
    },
    SET_CURRENT_PAGE: function SET_CURRENT_PAGE() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        currentPage: action.value
      });
    },
    SET_USER_INFO: function SET_USER_INFO() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        user: action.value
      });
    },
    SET_SELECTED_ORGANISATION: function SET_SELECTED_ORGANISATION() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        selectedOrg: action.value
      });
    },
    SET_TWO_FA_ENABLED: function SET_TWO_FA_ENABLED() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        twoFaEnabled: action.value
      });
    },
    SET_TOTAL_BALANCE: function SET_TOTAL_BALANCE() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        totalBalance: action.value
      });
    },
    SET_TOTAL_INTEREST: function SET_TOTAL_INTEREST() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        totalInterest: action.value
      });
    },
    SET_SELECTED_ACCOUNT: function SET_SELECTED_ACCOUNT() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        selectedAccount: action.value
      });
    },
    SET_CONTACTS_UPDATED: function SET_CONTACTS_UPDATED() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        contactsUpdated: action.value
      });
    }
  };
  callbacks[action.type]();
  return newState;
};

var DashboardContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  state: initialState,
  dispatch: function dispatch() {}
});

var DashboardProvider = function DashboardProvider(_ref) {
  var children = _ref.children,
      initialStateFromProps = _ref.initialStateFromProps;

  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialStateFromProps || initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var memoizedState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(DashboardContext.Provider, {
    value: memoizedState,
    children: children
  });
};



/***/ }),

/***/ 12454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getCurrentTheme; }
/* harmony export */ });
/* unused harmony export setTheme */
var setTheme = function setTheme(theme) {
  if (true) {
    localStorage.setItem('theme', theme);
  }
};
var getCurrentTheme = function getCurrentTheme() {
  if (true) {
    return localStorage.getItem('theme') || "light";
  }

  return "light";
};

/***/ }),

/***/ 59269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59181);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






var useErrorHandling = function useErrorHandling() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState[0],
      setError = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var withErrorHandling = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(apiCall) {
      var _len,
          params,
          _key,
          _yield$apiCall,
          data,
          _err$response,
          _err$response$data,
          _err$response2,
          _err$response2$data,
          ignoredErrors,
          statusCode,
          statusMessage,
          _window$Rollbar,
          message,
          _args = arguments;

      return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              for (_len = _args.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                params[_key - 1] = _args[_key];
              }

              _context.next = 4;
              return apiCall.apply(void 0, params);

            case 4:
              _yield$apiCall = _context.sent;
              data = _yield$apiCall.data;
              setError(null);
              return _context.abrupt("return", {
                data: data,
                error: null
              });

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              // Status codes listed here should be expected errors (i.e wrong password token expiration etc)
              ignoredErrors = ["ERR_UNAUTHORIZED", "ERR_PASSWORD_WRONG", "ERR_LOGIN_CREDENTIALS"];
              statusCode = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.statusCode;
              statusMessage = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response2 = _context.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.statusMessage;

              if (!(statusCode === "ERR_UNAUTHORIZED" || statusCode === "ERR_FORBIDDEN")) {
                _context.next = 18;
                break;
              }

              _context.next = 18;
              return router.push("/login");

            case 18:
              if ( true && (!statusCode || !ignoredErrors.includes(statusCode))) {
                (_window$Rollbar = window.Rollbar) === null || _window$Rollbar === void 0 ? void 0 : _window$Rollbar.error(_context.t0);
              }

              if (false) {}

              message = statusCode === "ERR_INVALID_ADDRESS" ? statusMessage : _components_errors__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[statusCode];
              message && setError(message);
              return _context.abrupt("return", {
                error: {
                  statusCode: statusCode,
                  message: message
                }
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return {
    error: error,
    setError: setError,
    withErrorHandling: withErrorHandling
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useErrorHandling);

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 56058:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"v":"5.7.6","fr":60,"ip":135,"op":179,"w":375,"h":471,"nm":"1.0.5 - User Entrance - Screen 5","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":5,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[188,236,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[60,60,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":10,"s":[120,120,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20,"s":[90,90,100]},{"t":30,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[92.571,92.571],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"op","nm":"Offset Paths 1","a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3},"ix":3,"mn":"ADBE Vector Filter - Offset","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"1 Stroke","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[92.571,92.571],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.921568627451,0.101960784314,0.101960784314,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"1 Fill","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":30,"s":[70]},{"t":180,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[188,236,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":30,"s":[55,55,100]},{"t":180,"s":[200,200,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"op","nm":"Offset Paths 1","a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3},"ix":3,"mn":"ADBE Vector Filter - Offset","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Stroke","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.921568627451,0.101960784314,0.101960784314,1],"ix":4},"o":{"a":0,"k":50.196,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Fill","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":30,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"6","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":75,"s":[70]},{"t":225,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[188,236,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":75,"s":[55,55,100]},{"t":225,"s":[200,200,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"op","nm":"Offset Paths 1","a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3},"ix":3,"mn":"ADBE Vector Filter - Offset","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Stroke","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.921568627451,0.101960784314,0.101960784314,1],"ix":4},"o":{"a":0,"k":50.196,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Fill","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":75,"op":345,"st":45,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"7","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":120,"s":[70]},{"t":270,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[188,236,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":120,"s":[55,55,100]},{"t":270,"s":[200,200,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"op","nm":"Offset Paths 1","a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3},"ix":3,"mn":"ADBE Vector Filter - Offset","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Stroke","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.921568627451,0.101960784314,0.101960784314,1],"ix":4},"o":{"a":0,"k":50.196,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Fill","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":120,"op":390,"st":90,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"2","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":165,"s":[70]},{"t":315,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[188,236,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":165,"s":[55,55,100]},{"t":315,"s":[200,200,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"op","nm":"Offset Paths 1","a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3},"ix":3,"mn":"ADBE Vector Filter - Offset","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Stroke","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[154.286,154.286],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.921568627451,0.101960784314,0.101960784314,1],"ix":4},"o":{"a":0,"k":50.196,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"2 Fill","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":165,"op":435,"st":135,"bm":0}],"markers":[]}');

/***/ })

}]);